import { useTranslations } from '@vocab/react';
import { Box, IconThumb, Text } from 'braid-design-system';

import translations from './.vocab';

import * as styles from './index.css';

export type InsightsFooterProps = {
  showApplyButton: boolean;
  applySuggestionsClicked?: () => void;
} & (
  | { showApplyButton: true; applySuggestionsClicked: () => void }
  | { showApplyButton: false; applySuggestionsClicked?: () => void }
);

export const InsightsFooter = ({
  showApplyButton,
  applySuggestionsClicked,
}: InsightsFooterProps) => {
  const { t } = useTranslations(translations);

  const thumbsUpClicked = () => {
    // TODO: apply suggestions in a later story
  };

  const thumbsDownClicked = () => {
    // TODO: apply suggestions in a later story
  };

  return (
    <Box
      display="flex"
      paddingTop="medium"
      justifyContent={showApplyButton ? 'spaceBetween' : 'flexEnd'}
      className={styles.footerContainer}
    >
      {showApplyButton && (
        <Box
          component="button"
          className={styles.applyButton}
          borderRadius="standard"
          onClick={applySuggestionsClicked}
          background="customDark"
          padding="small"
          data-testid="applySuggestions"
        >
          <Text size="small" weight="medium">
            {t('apply-suggestions-text')}
          </Text>
        </Box>
      )}
      <Box display="flex" justifyContent="flexEnd" alignItems="center">
        <Text size="small">{t('feedback-text')}</Text>
        <Box
          component="button"
          className={styles.thumbsUpButton}
          onClick={thumbsUpClicked}
          aria-label="Helpful?"
        >
          <IconThumb size="xsmall" title="thumbs up" titleId="thumbsUp" />
        </Box>
        <Box
          component="button"
          className={styles.thumbsDownButton}
          onClick={thumbsDownClicked}
          aria-label="Not helpful"
        >
          <IconThumb
            size="xsmall"
            direction="down"
            title="thumbs down"
            titleId="thumbsDown"
          />
        </Box>
      </Box>
    </Box>
  );
};
